import axios from 'axios';
import { Message } from 'element-ui';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' }
});

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('admin_token');
    if (token) config.headers['Authorization'] = 'Bearer ' + token;
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const config = response.config;
    // ✅ 如果请求配置了 responseType: 'blob'，直接返回 response（用于文件下载）
    if (config.responseType === 'blob') {
      return response;
    }

    const res = response.data;
    // 判断 code 是否为 0（成功）
    if (res.code !== undefined && res.code !== 0 && res.code !== 200) {
      Message({
        message: res.message || '请求失败',
        type: 'error',
        duration: 3000
      });
      if (res.code === 401) {
        localStorage.removeItem('admin_token');
        window.location.href = '/admin/login';
      }
      return Promise.reject(new Error(res.message || 'Error'));
    }
    return res;
  },
  error => {
    Message({
      message: error.message || '网络异常，请稍后重试',
      type: 'error',
      duration: 3000
    });
    return Promise.reject(error);
  }
);

export default service;